export class ListenerSet {
    listeners = new Set();
    add(fn) {
        this.listeners.add(fn);
        return () => {
            this.listeners.delete(fn);
        };
    }
    invoke(...args) {
        for (const fn of this.listeners)
            fn(...args);
    }
    get size() {
        return this.listeners.size;
    }
}
//# sourceMappingURL=ListenerSet.js.map